export const SERVER_ERROR_CODES = {
  UNVERIFIED_MODEL_NOT_APPROVED: 1076,
  EMAIL_DOMAIN_UNAUTHORIZED_TO_SIGN_IN: 1077,
  EMAIL_MISMATCH_ERROR_CODE: 1015,
  EMAIL_PASSWORD_LOGIN_NOT_ALLOWED: 1082,
};
